export interface NotFoundProps {
    text: string;
}

export const NotFound = ({ text }: NotFoundProps) => {
    return (
        <div className="flex-1 w-full flex items-center justify-center">
            <div className="flex flex-col items-center gap-4 py-16">
                <span className="material-symbols-rounded !text-7xl text-gray-light light:text-foreground dark:text-foreground">error</span>
                <p className="text-gray-light light:text-foreground dark:text-foreground">{text}</p>
            </div>
        </div>
    );
};
